"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMeasurements = void 0;
const app_platform_common_1 = require("@semios/app-platform-common");
const makeMeasurements = (formatNumber, tTemplatesRaw, tUnitSymbolsRaw, lng) => {
    const tTemplates = lng ? (k, o) => tTemplatesRaw(k, { ...o, lng }) : tTemplatesRaw;
    const tUnitSymbols = lng
        ? (k, o) => tUnitSymbolsRaw(k, { ...o, lng })
        : tUnitSymbolsRaw;
    const makeNumberMeasurementRenderer = (unitSymbol) => {
        const renderValue = (value, fractionDigits) => {
            if ((0, app_platform_common_1.isNil)(value))
                return tTemplates('-');
            let val = value.toFixed(fractionDigits);
            // prevent things like '-0.00'
            if (+val === 0) {
                return val.replace('-', '');
            }
            return val;
            // TODO: i18n - Can we use formatNumber instead of toFixed?
            // return formatNumber(value, {
            //   minimumFractionDigits: fractionDigits,
            //   maximumFractionDigits: fractionDigits,
            // })
        };
        const renderUnit = () => {
            return tUnitSymbols(unitSymbol);
        };
        const renderValueWithUnit = (value, fractionDigits) => {
            return tTemplates('{{value}} {{unitSymbol}}', {
                value: renderValue(value, fractionDigits),
                unitSymbol: renderUnit(),
            });
        };
        return {
            value: renderValue,
            unit: renderUnit,
            valueWithUnit: renderValueWithUnit,
        };
    };
    return {
        acreFeet: makeNumberMeasurementRenderer('acre-ft'),
        centimeters: makeNumberMeasurementRenderer('cm'),
        cubicMeter: makeNumberMeasurementRenderer('m³'),
        cubicMeterPerHour: makeNumberMeasurementRenderer('m³/h'),
        cubicMeterPerSecond: makeNumberMeasurementRenderer('m³/s'),
        cubicFeet: makeNumberMeasurementRenderer('cubic ft'),
        cubicFeetPerSecond: makeNumberMeasurementRenderer('CFS'),
        degreeDaysCelsius: makeNumberMeasurementRenderer('DD (°C)'),
        degreeDaysFahrenheit: makeNumberMeasurementRenderer('DD (°F)'),
        degreesCelsius: makeNumberMeasurementRenderer('°C'),
        degreesFahrenheit: makeNumberMeasurementRenderer('°F'),
        diseaseSeverityValue: makeNumberMeasurementRenderer('DSV'),
        feet: makeNumberMeasurementRenderer('ft'),
        gallons: makeNumberMeasurementRenderer('gal'),
        gallonsPerHour: makeNumberMeasurementRenderer('GPH'),
        gallonsPerMinute: makeNumberMeasurementRenderer('GPM'),
        hours: makeNumberMeasurementRenderer('hr'),
        inches: makeNumberMeasurementRenderer('in'),
        inchesPerHour: makeNumberMeasurementRenderer('inch/hr'),
        kilometersPerHour: makeNumberMeasurementRenderer('kph'),
        kilopascals: makeNumberMeasurementRenderer('kPa'),
        litersPerSecond: makeNumberMeasurementRenderer('L/s'),
        megaLiters: makeNumberMeasurementRenderer('ML'),
        liters: makeNumberMeasurementRenderer('L'),
        litersPerHour: makeNumberMeasurementRenderer('LPH'),
        meters: makeNumberMeasurementRenderer('m_meters'),
        metersPerSecond: makeNumberMeasurementRenderer('mps'),
        metersPerHour: makeNumberMeasurementRenderer('m/hr'),
        micrometers: makeNumberMeasurementRenderer('µm'),
        milesPerHour: makeNumberMeasurementRenderer('mph'),
        millimeters: makeNumberMeasurementRenderer('mm'),
        millimetersPerHour: makeNumberMeasurementRenderer('mm/hr'),
        minutes: makeNumberMeasurementRenderer('m_minutes'),
        percentage: makeNumberMeasurementRenderer('%'),
        poundsPerSquareInch: makeNumberMeasurementRenderer('PSI'),
        revolutionsPerMinute: makeNumberMeasurementRenderer('RPM'),
        riskPredictionValue: makeNumberMeasurementRenderer('RPV'),
        voltage: makeNumberMeasurementRenderer('V'),
    };
};
exports.makeMeasurements = makeMeasurements;
//# sourceMappingURL=makeMeasurements.js.map